import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { fetchWithHeaders } from 'utils'

interface RemoveEmployeePayScheduleParams {
  payScheduleId: string
  employeeId: string
}

export function useRemoveEmployeePaySchedule () {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ payScheduleId, employeeId }: RemoveEmployeePayScheduleParams) => {
      const response = await fetchWithHeaders('/api/web/payroll/pay_schedules/remove_employee', {
        method: 'DELETE',
        body: JSON.stringify({
          pay_schedule_id: payScheduleId,
          employee_id: employeeId,
        }),
      })

      if (!response.ok) {
        throw new Error('Failed to remove employee from pay schedule')
      }

      return response.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['employers', 'employees'] })
      toast.success('Removed employee from pay schedule')
    },
    onError: (error: Error) => {
      toast.error(error.message)
    },
  })
}
